import React from 'react'
import { EmptyPlaceholder } from '@components/common'

const BankForm: React.FC = () => (
  <EmptyPlaceholder
    title="Bank is not yet implemented"
    content="This payment method is not available yet."
    icon="mgc_information_fill"
  />
)

export default BankForm
